import { Injectable, inject } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { GLOBAL_GRAPHQLGATEWAY_NAME_NO_OVERLAY } from '../../../../graphql.module';
import {
    GetDigitalSignatureWithFiles,
    GetDigitalSignatureWithFilesVariables,
    GetQuoteDigitalSignatures,
    GetQuoteDigitalSignaturesVariables,
} from './query/GetDigitalSignatures.generated';

@Injectable({ providedIn: 'root' })
export class DigitalSignatureApiService {
    #apollo = inject(Apollo);
    get #gql() {
        return this.#apollo.use(GLOBAL_GRAPHQLGATEWAY_NAME_NO_OVERLAY);
    }

    getQuoteDigitalSignatures(variables: GetQuoteDigitalSignaturesVariables) {
        return this.#gql.query({
            query: GetQuoteDigitalSignatures,
            variables,
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
        });
    }
    getDigitalSignatureWithFiles(variables: GetDigitalSignatureWithFilesVariables) {
        return this.#gql.query({
            query: GetDigitalSignatureWithFiles,
            variables,
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
        });
    }
}
